import React from "react";
import PropTypes from "prop-types";
import { connectHits } from "react-instantsearch-dom";

import PersonPresenter from "presenters/PersonPresenter";
import CalendarDetailModal from "components/CalendarDetailModal";

const AlgoliaSearchResults = ({ person, dateType, dateToCelebrate, onClose, hits }) => {
  return (
    <CalendarDetailModal
      person={person}
      dateType={dateType}
      dateToCelebrate={dateToCelebrate}
      onClose={onClose}
      templateGroups={hits}
    />
  );
};

AlgoliaSearchResults.propTypes = {
  person: PersonPresenter.shape().isRequired,
  dateType: PropTypes.string.isRequired,
  dateToCelebrate: PropTypes.string,
  onClose: PropTypes.func,
  hits: PropTypes.arrayOf(PropTypes.shape()),
};

const SearchResults = connectHits(AlgoliaSearchResults);

export default SearchResults;
